import { render, staticRenderFns } from "./CoinStoreDealsManager.vue?vue&type=template&id=3aebceea&scoped=true&"
import script from "./CoinStoreDealsManager.vue?vue&type=script&lang=ts&"
export * from "./CoinStoreDealsManager.vue?vue&type=script&lang=ts&"
import style0 from "./CoinStoreDealsManager.vue?vue&type=style&index=0&id=3aebceea&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aebceea",
  null
  
)

export default component.exports